import { styled } from "@material-ui/core";

/**
 * Our standard page layout, providing consistent padding and spacing around
 * the edges of the screen.
 *
 * This should be used to wrap your FooPage component as the outermost element.
 *
 * Using it inside a Route Layout is not recommended else each child is forced
 * to adopt these margins with no control.
 *
 * Can be made dense by passsing the `data-dense` prop.
 */
export const Page = styled("main")(({ theme }) => ({
  padding: theme.spacing(2),
  [theme.breakpoints.up("sm")]: {
    padding: theme.spacing(2, 4),
  },
  [theme.breakpoints.up("md")]: {
    padding: theme.spacing(4, 14),
    "&[data-dense]": {
      padding: theme.spacing(2, 6),
    },
  },
  [theme.breakpoints.up("lg")]: {
    padding: theme.spacing(4, 20),
    "&[data-dense]": {
      padding: theme.spacing(2, 10),
    },
  },
}));
